import React from 'react';
import { HealthDocumentationFileRef } from '../../../Ecard/Interfaces/HealthDocumentationFileRef.interface';

const PatientTreatmentContext = React.createContext({
	patientId: '',
	caseId: undefined,
	isMyCase: undefined,
	/** Files sent from Zdravotnická dokumentace, waiting for Dočasné úložiště → Nová zásilka. */
	filesToSend: undefined as HealthDocumentationFileRef[] | null | undefined,
	/** Called once Dočasné úložiště took the files over, so they don't come back on the next visit. */
	onFilesToSendTaken: undefined as (() => void) | undefined,
});

interface PatientTreatmentContextProviderProps {
	children: React.ReactElement | React.ReactElement[];
	patientId: string;
	caseId?: string;
	isMyCase?: boolean;
	filesToSend?: HealthDocumentationFileRef[] | null;
	onFilesToSendTaken?: () => void;
}

const PatientTreatmentContextProvider: React.FC<
	PatientTreatmentContextProviderProps
> = props => {
	const {
		children,
		patientId,
		caseId = null,
		isMyCase = false,
		filesToSend,
		onFilesToSendTaken,
	} = props;

	return (
		<PatientTreatmentContext.Provider
			// @ts-ignore
			value={{ patientId, caseId, isMyCase, filesToSend, onFilesToSendTaken }}>
			{children}
		</PatientTreatmentContext.Provider>
	);
};

export const usePatientTreatmentContext = () =>
	React.useContext(PatientTreatmentContext);

export default PatientTreatmentContextProvider;
